import { twMerge } from 'tailwind-merge';

export const DirittoCircleIcon = ({ className }: { className?: string }) => (
  <svg
    className={twMerge('size-[24px]', className)}
    width="100%"
    height="100%"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect width="56" height="56" rx="28" fill="#915FFF" />
    <path
      d="M29.5684 12.5268L30.5033 23.262C29.2486 22.4694 27.123 21.8479 24.9642 22.0358C19.3499 22.5312 15.5171 27.5152 16.0493 33.6313C16.5545 39.4228 21.0728 42.8323 26.2809 42.9956C29.0812 43.0834 31.7369 41.841 33.3704 40.4136L38 39.9962L35.562 12L29.5684 12.5268ZM23.1442 29.1501C23.9165 28.0896 25.0521 27.4632 26.4288 27.3386C26.5863 27.3246 26.7419 27.3174 26.8955 27.3171C29.4214 27.3171 31.3083 29.2266 31.5524 32.1108C31.8111 35.1706 30.0658 37.4813 27.3085 37.7305C25.9323 37.8556 24.7079 37.4421 23.7696 36.5361C22.8694 35.6669 22.305 34.3965 22.1849 32.9554C22.0633 31.5222 22.4036 30.1674 23.1442 29.1501Z"
      fill="white"
    />
    <rect x="0.5" y="0.5" width="55" height="55" rx="27.5" stroke="black" strokeOpacity="0.1" />
  </svg>
);
